export type UTMParams = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
};

export const getUTMParams = (): UTMParams => {
  const params = new URLSearchParams(window.location.search);

  return {
    utm_campaign: params.get('utm_campaign') || undefined,
    utm_content: params.get('utm_content') || undefined,
    utm_medium: params.get('utm_medium') || undefined,
    utm_source: params.get('utm_source') || undefined,
    utm_term: params.get('utm_term') || undefined,
  };
};

export const initUTMTracking = () => {
  const current = getUTMParams();
  const hasUTM = Object.values(current).some(Boolean);

  if (hasUTM) {
    sessionStorage.setItem('utm_params', JSON.stringify(current));
  }
};

export const getStoredUTMParams = (): UTMParams => {
  try {
    return JSON.parse(sessionStorage.getItem('utm_params') || '{}');
  } catch {
    return {};
  }
};
